$(document).ready(function () {
  let [faucetAmount, hourAmount, hourlyRate, partsCost] = [1, 1, 25, 50];
  let range;
  const [quickZip1, quickZip2, quickZip3] = [90011, 77494, 34787];
  const [quickFaucet1, quickFaucet2, quickFaucet3] = [1, 2, 3];

  $('#pro-yes').click(function () {
    $('.w-round div:nth-child(2)').trigger('tap');
  });

  $('#pro-no').click(function () {
    $('.w-round div:nth-child(2)').trigger('tap');
  });

  $('#zip-quick-1').click(function () {
    $('#zip-code').val(quickZip1);
    updateTotalCost();
  });
  $('#zip-quick-2').click(function () {
    $('#zip-code').val(quickZip2);
    updateTotalCost();
  });
  $('#zip-quick-3').click(function () {
    $('#zip-code').val(quickZip3);
    updateTotalCost();
  });

  $('#faucet-quick-1').click(function () {
    $('#faucet-amount').val(quickFaucet1);
    $('.w-round div:nth-child(3)').trigger('tap');
    updateTotalCost();
  });
  $('#faucet-quick-2').click(function () {
    $('#faucet-amount').val(quickFaucet2);
    $('.w-round div:nth-child(3)').trigger('tap');
    updateTotalCost();
  });
  $('#faucet-quick-3').click(function () {
    $('#faucet-amount').val(quickFaucet3);
    $('.w-round div:nth-child(3)').trigger('tap');
    updateTotalCost();
  });

  function updateTotalCost() {
    console.log('updateTotalCost called');
    let faucetAmount = Number($('#faucet-amount').val());
    let fullZipCode = $('#zip-code').val();
    range = getLocationInfo(fullZipCode);
    getLocalPrices(range);
    calculateTotalCost(faucetAmount, hourAmount, hourlyRate, partsCost);
  }

  $('#faucet-amount').on('input', updateTotalCost);
  $('#hour-amount').on('input', updateTotalCost);
  $('#zip-code').on('input', updateTotalCost);
  $('#parts-cost').on('input', updateTotalCost);
  $('#hourly-rate').on('input', updateTotalCost);

  function getLocationInfo(fullZipCode) {
    fullZipCode = fullZipCode.toString();
    let shortZipCode = Number(fullZipCode.substring(0, 3));

    // Location mappings
    let locationMap = {
      '995-999': 'alaska',
      '000': 'alaska',
      '001': 'international',
      // '002-004,099,192,213,269,343,345,353,399,419,428-429,459,509,517-519,529,533,536,552,568,578-579,589,621,632,642-643,649,659,663,682,694-699,702,709,715,732,742,817-819,839,842,848-849,854,861-862,866-869,872,876,886-889,892,896,899,909,929,987':
      //   'notUsed',
      '100-149': 'newYork',
      '005': 'newYork',
      '006-007': 'puertoRico',
      '009': 'puertoRico',
      '008': 'virginIslands',
      '010-027': 'massachusetts',
      '055': 'massachusetts',
      '028-029': 'rhodeIsland',
      '030-038': 'newHampshire',
      '039-049': 'maine',
      '050-054': 'vermont',
      '056-059': 'vermont',
      '060-069': 'connecticut',
      '070-089': 'newJersey',
      '090-098': 'armedForcesEurope',
      '150-191': 'pennsylvania',
      '193-196': 'pennsylvania',
      '197-199': 'delaware',
      '202-205': 'washingtonDC',
      '200,569': 'washingtonDC',
      '206-212': 'maryland',
      '214-219': 'maryland',
      '220-246': 'virginia',
      201: 'virginia',
      '247-268': 'westVirginia',
      '270-289': 'northCarolina',
      '290-299': 'southCarolina',
      '300-319': 'georgia',
      398: 'georgia',
      '320-339': 'florida',
      '341-342': 'florida',
      344: 'florida',
      '346-347': 'florida',
      349: 'florida',
      340: 'armedForcesAmerica',
      '350-352': 'alabama',
      '354-369': 'alabama',
      '370-385': 'tennessee',
      '386-397': 'mississippi',
      '400-418': 'kentucky',
      '420-427': 'kentucky',
      '430-458': 'ohio',
      '460-479': 'indiana',
      '480-499': 'michigan',
      '500-508': 'iowa',
      '510-516': 'iowa',
      '520-528': 'iowa',
      '530-532': 'wisconsin',
      '534-535': 'wisconsin',
      '537-549': 'wisconsin',
      '550-551': 'minnesota',
      '553-567': 'minnesota',
      '570-577': 'southDakota',
      '580-588': 'northDakota',
      '590-599': 'montana',
      '600-620': 'illinois',
      '622-629': 'illinois',
      '630-631': 'missouri',
      '633-641': 'missouri',
      '644-648': 'missouri',
      '650-658': 'missouri',
      '660-662': 'kansas',
      '664-679': 'kansas',
      '680-681': 'nebraska',
      '683-693': 'nebraska',
      '700-701': 'louisiana',
      '703-708': 'louisiana',
      '710-714': 'louisiana',
      '716-729': 'arkansas',
      '730-731': 'oklahoma',
      '734-741': 'oklahoma',
      '743-749': 'oklahoma',
      '750-799': 'texas',
      733: 'texas',
      '800-816': 'colorado',
      '820-831': 'wyoming',
      '832-838': 'idaho',
      '840-841': 'utah',
      '843-847': 'utah',
      '850-853': 'arizona',
      '855-857': 'arizona',
      '859-860': 'arizona',
      '863-865': 'arizona',
      '870-871': 'newMexico',
      '873-875': 'newMexico',
      '877-885': 'newMexico',
      '890-891': 'nevada',
      '893-895': 'nevada',
      '897-898': 'nevada',
      '900-908': 'california',
      '910-928': 'california',
      '930-961': 'california',
      '962-966': 'armedForcesCentral',
      '967-968': 'hawaii',
      969: 'guam',
      '970-979': 'oregon',
      '980-986': 'washington',
      '988-994': 'washington',
    };

    // Check if the truncatedZipCode matches any range in the locationMap
    for (let range in locationMap) {
      if (range.includes('-')) {
        let [start, end] = range.split('-').map(Number);
        if (shortZipCode >= start && shortZipCode <= end) {
          return locationMap[range];
        }
      } else {
        if (shortZipCode === Number(range)) {
          return locationMap[range];
        }
      }
    }

    return 'california'; // Default if no match is found
  }

  function getLocalPrices(range) {
    switch (range) {
      case 'alabama':
        hourlyRate = 23.8;
        break;
      case 'alaska':
        hourlyRate = 41.74;
        break;
      case 'arizona':
        hourlyRate = 27.7;
        break;
      case 'arkansas':
        hourlyRate = 22.48;
        break;
      case 'california':
        hourlyRate = 35.75;
        break;
      case 'colorado':
        hourlyRate = 29.69;
        break;
      case 'connecticut':
        hourlyRate = 32.94;
        break;
      case 'delaware':
        hourlyRate = 29.57;
        break;
      case 'florida':
        hourlyRate = 23.48;
        break;
      case 'georgia':
        hourlyRate = 28.29;
        break;
      case 'hawaii':
        hourlyRate = 36.8;
        break;
      case 'idaho':
        hourlyRate = 29.2;
        break;
      case 'illinois':
        hourlyRate = 42.3;
        break;
      case 'indiana':
        hourlyRate = 32.38;
        break;
      case 'iowa':
        hourlyRate = 29.96;
        break;
      case 'kansas':
        hourlyRate = 27.72;
        break;
      case 'kentucky':
        hourlyRate = 28.46;
        break;
      case 'louisiana':
        hourlyRate = 28.3;
        break;
      case 'maine':
        hourlyRate = 28.7;
        break;
      case 'maryland':
        hourlyRate = 29.28;
        break;
      case 'massachusetts':
        hourlyRate = 39.43;
        break;
      case 'michigan':
        hourlyRate = 31.05;
        break;
      case 'minnesota':
        hourlyRate = 36.87;
        break;
      case 'mississippi':
        hourlyRate = 24.13;
        break;
      case 'missouri':
        hourlyRate = 31.71;
        break;
      case 'montana':
        hourlyRate = 33.39;
        break;
      case 'nebraska':
        hourlyRate = 29.13;
        break;
      case 'nevada':
        hourlyRate = 31.27;
        break;
      case 'newHampshire':
        hourlyRate = 28.53;
        break;
      case 'newJersey':
        hourlyRate = 40.46;
        break;
      case 'newMexico':
        hourlyRate = 24.58;
        break;
      case 'newYork':
        hourlyRate = 40.1;
        break;
      case 'northCarolina':
        hourlyRate = 23.66;
        break;
      case 'northDakota':
        hourlyRate = 28.24;
        break;
      case 'ohio':
        hourlyRate = 31.23;
        break;
      case 'oklahoma':
        hourlyRate = 25.38;
        break;
      case 'oregon':
        hourlyRate = 39.24;
        break;
      case 'pennsylvania':
        hourlyRate = 32.93;
        break;
      case 'puertoRico':
        hourlyRate = 12.55;
        break;
      case 'rhodeIsland':
        hourlyRate = 31.64;
        break;
      case 'southCarolina':
        hourlyRate = 23.9;
        break;
      case 'southDakota':
        hourlyRate = 24.95;
        break;
      case 'tennessee':
        hourlyRate = 26.5;
        break;
      case 'texas':
        hourlyRate = 26.58;
        break;
      case 'utah':
        hourlyRate = 28.09;
        break;
      case 'vermont':
        hourlyRate = 26.07;
        break;
      case 'virginIslands':
        hourlyRate = 25.83;
        break;
      case 'virginia':
        hourlyRate = 26.46;
        break;
      case 'washington':
        hourlyRate = 37.77;
        break;
      case 'washingtonDC':
        hourlyRate = 37.15;
        break;
      case 'westVirginia':
        hourlyRate = 26.49;
        break;
      case 'wisconsin':
        hourlyRate = 34.24;
        break;
      case 'wyoming':
        hourlyRate = 34.24;
        break;
    }
  }

  function calculateTotalCost(faucetAmount, hourAmount, hourlyRate, partsCost) {
    let timeToFix = hourAmount * faucetAmount * 0.9;
    let lowCost = (timeToFix * (hourlyRate * 2) + partsCost).toFixed(0);
    let highCost = (timeToFix * (hourlyRate * 10) + partsCost).toFixed(0);
    let laborCosts1 = (timeToFix * (hourlyRate * 2)).toFixed(0);
    let laborCosts2 = (timeToFix * (hourlyRate * 10)).toFixed(0);
    let laborRange = `$${laborCosts1}-$${laborCosts2}`;
    let hourlyRate1 = (hourlyRate * 2).toFixed(0);
    let hourlyRate2 = (hourlyRate * 10).toFixed(0);
    let hourlyRange = `$${hourlyRate1}-$${hourlyRate2}`;
    let costRange;
    if (faucetAmount <= 0) {
      costRange = `$0`;
    } else {
      costRange = `$${lowCost}-$${highCost}`;
    }

    $('#cost-range, #cost-range2').text(costRange);
    $('#labor-costs').text(laborRange);
    $('#part-costs').text('$' + partsCost);
    $('#hourly-rate').text(hourlyRange);
    $('#hour-amount').text(timeToFix);
    $('#faucet-amount').text(faucetAmount);
  }

  var inputElement = $('#faucet-amount');
  var inputElement2 = $('#zip-code');

  inputElement.on('keydown', function (event) {
    if (event.which === 13 || event.key === 'Enter') {
      event.preventDefault();
      $('#next-button').trigger('tap');
      $(document.activeElement).blur();
    }
  });

  inputElement.on('input', function (event) {
    if (event.originalEvent.inputType === 'insertLineBreak') {
      event.preventDefault();
      $('#next-button').trigger('tap');
      $(document.activeElement).blur();
    }
  });

  inputElement2.on('keydown', function (event) {
    if (event.which === 13 || event.key === 'Enter') {
      event.preventDefault();
      $(document.activeElement).blur();
    }
  });

  inputElement2.on('input', function (event) {
    if (event.originalEvent.inputType === 'insertLineBreak') {
      event.preventDefault();
      $(document.activeElement).blur();
    }
  });

  $('.form_input-field').submit(function (event) {
    return false;
  });

  function loadData() {
    let fullZipCode = sessionStorage.getItem('fullZipCode') || 90210;
    let faucetAmount = parseInt(sessionStorage.getItem('faucetAmount')) || 1;
    range = getLocationInfo(fullZipCode);
    getLocalPrices(range);
    calculateTotalCost(faucetAmount, hourAmount, hourlyRate, partsCost);
  }

  loadData();
});
